import React from 'react';
import _ from 'lodash';
import injectTapEventPlugin from 'react-tap-event-plugin';

import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { Router, browserHistory } from 'react-router';

import routes from '../shared/routes';
import { configureStore } from '../shared/redux/store/configureStore';
import SimpleIsoFetch, { syncBindingsWithStore } from 'simple-iso-fetch';

// boolean checks
const isProd = process.env.NODE_ENV === 'production';
const enableDevTools = process.env.ENABLE_DEV_TOOLS === 'true';

// grab initial state off window
const simpleIsoFetch = new SimpleIsoFetch();

const store = configureStore(browserHistory, simpleIsoFetch);

// attach bindings to store
syncBindingsWithStore(simpleIsoFetch, store);

// react's HTML5 history handler
const history = syncHistoryWithStore(browserHistory, store);

// enable tap events throughout app (temporary patch)
injectTapEventPlugin();

// determine where react hooks to actual DOM
const DomEntryPoint = document.getElementById('root');

// polyfill or augment ES6 native promises with 'bluebird' library throughout app
window.Promise = window.Promise && _.merge(window.Promise, require('bluebird')) || require('bluebird');

// enable debugger if in dev and client
if (!isProd) {
  window.React = React;
}

const hashLinkScroll = () => {
  const { hash } = window.location;
  if (hash !== '') {
    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 0);
  }
};

// // inform dev users if isomorphic load failed (checks for 'data-react-checksum' attribute)
// if (!isProd) {
//   if (!DomEntryPoint || !DomEntryPoint.firstChild || !DomEntryPoint.firstChild.attributes || !DomEntryPoint.firstChild.attributes['data-react-checksum'] && (!DomEntryPoint.firstChild.firstChild || !DomEntryPoint.firstChild.firstChild.attributes || !DomEntryPoint.firstChild.firstChild.attributes['data-react-checksum'])) { // eslint-disable-line max-len
//     console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.'); // eslint-disable-line
//   }
// }

// hook client-side app to DOM
render(
  <Provider store={store}>
    <Router history={history} routes={routes(store)} onUpdate={hashLinkScroll}/>
  </Provider>,
  DomEntryPoint
);

// enable DevTools if in dev and if user does not have redux Devtools extension installed
if (!isProd && !window.devToolsExtension && enableDevTools) {
  const DevTools = require('../shared/redux/DevTools').default; // need to specify "default" when getting require to play with "export default"
  const devToolsDest = document.createElement('div');
  DomEntryPoint.parentNode.insertBefore(devToolsDest, DomEntryPoint.nextSibling);
  render(
    <Provider store={store} key='provider'>
      <DevTools />
    </Provider>,
    devToolsDest
  );
}

// @cc_on is conditional compilation that IE Understands
const isIE = /*@cc_on!@*/false || !!document.documentMode;
if (isIE) {
  document.body.setAttribute('spellcheck', 'false');
}



// WEBPACK FOOTER //
// ./client/index.js